import { ThemedText } from "@/components/ThemedText";

export default function NewInvestigationPage() {
  return <ThemedText>New Investigation (Placeholder)</ThemedText>;
}
